import React from 'react';
import { Controller } from 'react-hook-form';
import { DateField } from '@mui/x-date-pickers/DateField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export const FormInputDate = (props) => {
  const {
    name,
    control,
    label,
    register,
    errors,
    helperText,
    minDate,
    maxDate,
    readOnly,
  } = props;

  const getValue = new Date(props.value);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Controller
        name={name}
        control={control}
        register={register}
        render={({
          field: { onChange, value },
          fieldState: { error },
          formState,
        }) => (
          <DateField
            primary={errors}
            label={label}
            value={getValue === '' ? null : getValue}
            minDate={minDate}
            maxDate={maxDate}
            onChange={onChange}
            readOnly={readOnly}
            variant="standard"
            error={errors}
            helperText={helperText}
            style={{ width: '100%', marginBottom: '20px' }}
          />
        )}
      />
    </LocalizationProvider>
  );
};
